export const login = (token) => {
  localStorage.setItem("adminToken", token);
  localStorage.setItem("isLoggedIn", "true");
  return true;
};

export const logout = () => {
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("adminToken");
};

export const isLoggedIn = () => {
  return (
    localStorage.getItem("isLoggedIn") === "true" &&
    !!localStorage.getItem("adminToken")
  );
};

export const getToken = () => {
  return localStorage.getItem("adminToken");
};
